import {Component, OnInit} from '@angular/core';
import {Constants, redirectToLink} from '../../common/constants';
import {DeviceDetectorService} from 'ngx-device-detector';
import {SessionService} from '../../../services/session.service';
import {DialogService} from '../../../services/dialog.service';
import {Router} from '@angular/router';
import packageInfo from '../../../../../package.json';

@Component({
    selector: 'app-template',
    templateUrl: './template.component.html',
    styleUrls: ['./template.component.scss']
})
export class TemplateComponent implements OnInit {
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;

    constructor(
        private deviceService: DeviceDetectorService,
        private sessionService: SessionService,
        public router: Router,
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
    }

    ngOnInit(): void {
        /* LOCALIZACION */
        this.sessionService.getLocationUser().subscribe(
            (response: any) => {
                if (response) {
                    this.sessionService.getCountrieUser(response.location.lat, response.location.lng).subscribe(
                        (responseCountrie: any) => {
                            this.sessionService.setCountryData(responseCountrie.results[responseCountrie.results.length - 2]
                                .formatted_address);
                        }
                    );
                }
            }
        );
        console.log('v' + packageInfo.version);
    }

    openLink(link): void {
        redirectToLink(link);
    }

}
